import React, {
  useContext,
} from 'react'
import { QuestionAnswer as CPQuestionAnswer } from '@usap/widgets'
import { LocalContext } from '../../helpers/useLocalContext'
import QuestionAnswerProvider, { QuestionAnswerContext } from '../../contexts/questionAnswers.context'
import { formatBrandInText } from '../../transformers/BrandText'

const QAWidget = ({ title, Link }) => {
  const contextData = useContext(QuestionAnswerContext)
  const { questionsAnswers } = contextData
  const hasData = Boolean(questionsAnswers?.data?.questionAnswers?.length)
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  if (!hasData) {
    return null
  }
  return (
    <CPQuestionAnswer
      title={title}
      questionAnswer={questionsAnswers?.data?.questionAnswers}
      Link={Link}
      formatBrandInText={formatBrandInText}
      isBot={isBot}
    />
  )
}

export default function SeoQuestionAnswer({ dynamicApiData }) {
  const {
    headers,
    questions,
    products,
    canonicalUri,
  } = dynamicApiData || {}
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const title = headers?.questionAnswer || 'Product Questions & Answers'

  return (
    <QuestionAnswerProvider questions={questions} products={products} canonicalUri={canonicalUri}>
      <QAWidget title={title} Link={Link} />
    </QuestionAnswerProvider>
  )
}
